
  export default {
    data () {
      return {
        showDropdown: false,
        selectedItems: ['broadband'],
        items: [
          { id: 'broadband', value: 'broadband', label: 'Broadband', icon: 'wifi' },
          { id: 'tv', value: 'tv', label: 'TV', icon: 'tv' },
          { id: 'phone', value: 'phone', label: 'Home Phone', icon: 'phone' },
          { id: 'mobile', value: 'mobile', label: 'Mobile', icon: 'mobile' }
        ]
      };
    },
    computed: {
      displayedItems () {
        return this.selectedItems.map(itemValue => {
          const item = this.items.find(i => i.value === itemValue);
          return item ? item.label : '';
        }).join(', ');
      }
    },
    watch: {
      selectedItems (newVal) {
        this.$emit('selected-items-changed', newVal);
      },
      showDropdown (isOpen) {
        if (isOpen) {
          document.addEventListener('click', this.handleClickOutside);
        } else {
          document.removeEventListener('click', this.handleClickOutside);
        }
      }
    },
    created () {
      this.$emit('selected-items-changed', this.selectedItems);
    },
    beforeDestroy () {
      document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
      handleClickOutside (event) {
        if (!this.$refs.dropdownContainer.contains(event.target)) {
          this.showDropdown = false;
        }
      }
    }
  };
